import { SymbolModel } from '../model/SymbolModel'
import { isValueSymbol } from '../types/typeGuards'
/**
 * Helper function to update symbol data to its final value
 * @author Jordan Harrison - <jordan.harrison@1x2network.com>
 * @version 1.0.0
 */

/**
 * Restarts arn't animation value increases, ensure symbols display the final values when restarting
 * @param reels input symbol reels
 * @returns modified reels
 */
export function applyFinalValues(reels: SymbolModel[][]): SymbolModel[][] {
    return reels.map((reel) =>
        reel.map((symbol) => {
            const symbolModel = { ...symbol }

            if (isValueSymbol(symbolModel)) {
                const cash = { ...symbolModel.cash }
                cash.start = cash.end
                symbolModel.cash = cash
            }

            return symbolModel
        }),
    )
}
